
import {useState,useRef} from 'react';
import {useSelector}     from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import Translate from '../components/Translate';
import Scanner from '../components/Scanner';
import ToggleInput from '../components/ToggleInput';
import useLogin from '../hooks/useLogin';
/*
   @payment
   @input 
   @result
     <span className ='btn btn-sm btn-danger rounded'>
                                    <i className ='fa fa-barcode ' style ={{fontSize:'150%'}}></i>
                               </span>
*/
const Online = ()=>{

    useLogin(); //parse openID 

    const [value,setValue] = useState('');
    const {userInfo} = useSelector(state=>state.userLogin);

    const [toggle,setToggle] = useState(true);
    const buttonRef = useRef(null);


    const handleScan = (result)=>{
        setValue(result);
        buttonRef.current.click();
    };
  
    return (
        <>
           
            <div className ='row mb-3' style = {{position:'relative'}}>
                  <ToggleInput handleToggle = {()=>setToggle(!toggle)}/>
            </div>
   
           {toggle && (
                <div className ='row'>
                  <div className ='form-group mx-auto' style ={{minWidth:'350px'}}>
                       <label><Translate k='trackingNumber' /><sup>*</sup></label>
                       <div className = 'input-group'>
                           <input 
                               type ='text' 
                               className ='form-control eparts-input' 
                               placeholder ='...'
                               readOnly = {true}
                               value = {value || ''}
                               ref = {buttonRef}
                              
                           />
                           <div className ='input-group-append'>
                               <Scanner 
                                  url = {`${window.location.href}`} 
                                  callBack = { handleScan }
                                 
                              />
                           </div>
                       </div>
                  </div>
                </div>
           )}

       
            <Tabs defaultActiveKey="home" className='mt-2'>
                <Tab eventKey="home" 
                    className ='rounded p-1' 
                    style = {{fontSize:'85%'}}
                    title={ 
                        <>
                        <i className ='fa fa-list mr-2'></i>
                        <Translate k= {'home'} />
                        </>
                    } 
                >


                
                    <div 
            
                        style ={{
                                marginTop:'8vh',
                                minHeight:'350px',
                                backgroundImage:'url('+require('../images/pallet.jpg')+')',
                                backgroundPosition: 'center',
                                backgroundSize: '80%',
                                backgroundRepeat: 'no-repeat',
                        }}
                    >
                    ...
                    </div>
                   


                </Tab>

                {userInfo?.PID === 'S37' && (
                     <Tab eventKey="catalog" 
                    className ='rounded p-1' 
                    style = {{fontSize:'85%'}}
                    title={ 
                        <>
                        <i className ='fa fa-file-pdf-o mr-2'></i>
                        <Translate k= {'catalog'} />
                        </>
                    } 
                >

                  应用信息 / 图纸信息
                   
                </Tab>
                )}

                {userInfo?.PID === 'S37' && (
                     <Tab eventKey="weChat" 
                    className ='rounded p-1' 
                    style = {{fontSize:'85%'}}
                    title={ 
                        <>
                        <i className ='fa fa-weixin mr-2'></i>
                        <Translate k= {'chat'} />
                        </>
                    } 
                >


                  online message
                  聊天工具
                   
                </Tab>
                )}



            </Tabs>
                    
            
            
        
        </>
    );

};

export default Online;
